import React, { useState } from 'react';
import { Container, Form, Button, Alert, Card, Spinner, InputGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthResponse } from '../types';

const Login: React.FC = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setSubmitting(true);
        try {
            const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
            const response = await axios.post<AuthResponse>(`${apiUrl}/auth/login`, {
                username,
                password,
            });
            localStorage.setItem('token', response.data.token);
            navigate('/');
        } catch (err: any) {
            setError(err.response?.data?.message || err.response?.data?.error || 'Не удалось войти. Проверьте логин и пароль.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="auth-bg d-flex align-items-center justify-content-center">
            <Container className="d-flex justify-content-center">
                <Card className="auth-card border-0">
                    <Card.Body className="p-4 p-md-5">
                        <div className="text-center mb-4">
                            <img src="/logo_blue.png" alt="TeriAI" height={48} className="mb-3" />
                            <h4 className="mb-1 fw-semibold">Админ-панель</h4>
                            <div className="muted-small">Войдите для управления клиниками и счетами</div>
                        </div>

                        {error && <Alert variant="danger" className="py-2">{error}</Alert>}

                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label className="small text-muted">Логин</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text><i className="bi bi-person"></i></InputGroup.Text>
                                    <Form.Control
                                        type="text"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        required
                                        autoFocus
                                        autoComplete="username"
                                        placeholder="Имя пользователя"
                                    />
                                </InputGroup>
                            </Form.Group>

                            <Form.Group className="mb-4">
                                <Form.Label className="small text-muted">Пароль</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text><i className="bi bi-lock"></i></InputGroup.Text>
                                    <Form.Control
                                        type={showPassword ? 'text' : 'password'}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                        autoComplete="current-password"
                                        placeholder="Пароль"
                                    />
                                    <Button variant="outline-secondary" type="button"
                                            onClick={() => setShowPassword((v) => !v)}
                                            tabIndex={-1} aria-label="Показать пароль">
                                        <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                                    </Button>
                                </InputGroup>
                            </Form.Group>

                            <Button className="w-100 fw-medium" type="submit" variant="primary"
                                    disabled={submitting || !username || !password}>
                                {submitting
                                    ? <><Spinner size="sm" animation="border" className="me-2" />Вход...</>
                                    : 'Войти'}
                            </Button>
                        </Form>

                        <div className="text-center mt-4 muted-small">
                            © {new Date().getFullYear()} TeriAI
                        </div>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
};

export default Login;
